// extracted by mini-css-extract-plugin
module.exports = {"parent":"Project_parent__BDasK","buttons":"Project_buttons__2ZFI1"};